import { render } from "./ApiDoc.vue?vue&type=template&id=b2669700&scoped=true"
import script from "./ApiDoc.vue?vue&type=script&lang=js"
export * from "./ApiDoc.vue?vue&type=script&lang=js"

import "./ApiDoc.vue?vue&type=style&index=0&id=b2669700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2669700"]])

export default __exports__